import { UserAvatar } from 'Components/shared/UserAvatar';
import { STORE_CONVERSATION, STORE_UI } from 'Constants/stores';
import { inject, MobXProviderContext, observer } from 'mobx-react';
import React from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { Styled } from './index.styles';
import { AttendeesProps } from './types';

const AttendeesObserver: React.FC<AttendeesProps> = ({
  conversation: { videoHistoryDetails },
}) => {
  const {
    person: { loadPersonByIdGetIfMissingGet, selectPersonValueById },
  } = React.useContext<RootStoreProps>(MobXProviderContext);

  const participants = videoHistoryDetails?.data?.participants;

  // Make sure we have the person data loaded for each participant
  React.useEffect(() => {
    participants?.forEach(({ personId }) => {
      // Guest users have personId 0. Skip PersonStore lookup so we don't incorrectly
      // cache a fallback under "0" in the shared PersonStore
      if (personId > 0) {
        void loadPersonByIdGetIfMissingGet(personId.toString());
      }
    });
  }, [participants, loadPersonByIdGetIfMissingGet]);

  return (
    <Styled.HistoryVideoAttendeesStyled>
      <Styled.SubtitleStyled>
        Attendees{' '}
        <Styled.NumAttendeesStyled>
          {participants?.length}
        </Styled.NumAttendeesStyled>
      </Styled.SubtitleStyled>
      {participants?.map((participant, index) => {
        const contact =
          participant.personId > 0
            ? selectPersonValueById(participant.personId)
            : null;

        const displayName = contact?.name || participant.displayName;

        return (
          <div
            key={`${participant.personId}-${participant.displayName}-${index}`}
            className={`semantic-flex-row semantic-flex-align-items-center ${
              index > 0 ? 'margin-top-1rem' : ''
            }`}
          >
            <UserAvatar
              name={displayName}
              presence={null}
              isInactive={contact?.deleted}
              image={contact?.avatarUrl}
              isPhone={participant.isPhone}
            />
            <Styled.PersonNameStyled>
              {displayName}
              {contact?.deleted && ' [Inactive]'}
            </Styled.PersonNameStyled>
          </div>
        );
      })}
    </Styled.HistoryVideoAttendeesStyled>
  );
};

export const Attendees = inject(
  STORE_CONVERSATION,
  STORE_UI
)(observer(AttendeesObserver));
